/**
 * Changelog entries for /changelog. Add releases when the app ships; newest first.
 *
 * Example entry:
 * {
 *   version: '1.0.0',
 *   title: 'First release',          // optional short headline after version
 *   paragraphs: ['Opening paragraph.'],
 *   bullets: ['Bullet point one.'],    // optional
 * }
 */
export const CHANGELOG = {
  pageTitle: "What's new",
  intro: 'Every release, newest first.',
  emptyMessage:
    'No public releases yet. Updates will appear here when Noor is available on the App Store and Google Play.',
  storeNote: 'Updates arrive through the App Store and Google Play when the app is live.',
  releases: [],
}
